import React from "react"
import styles from "./styles.scss"
import MenuBar from "components/MenuBar"
import Tags from "./Tags"
import { CaseStudyContext } from ".."
import { detect } from "detect-browser"
import cx from "classnames"

const browser = detect()

class Hero extends React.Component {
  static defaultProps = { backgroundColor: "#2f3542", backgroundOpacity: 0.8 }

  render() {
    const { backgroundColor, backgroundOpacity } = this.props
    const isIE = browser.name === "ie"

    return (
      <CaseStudyContext.Consumer>
        {caseStudy => {
          let renderProjectLogo = this.props.renderProjectLogo

          if (!renderProjectLogo) {
            renderProjectLogo = () => (
              <img
                className={styles.logo}
                src={caseStudy.projectLogo}
                alt={`${caseStudy.company} logo`}
              />
            )
          }

          let style = { backgroundImage: `url(${caseStudy.heroBackground})` }

          if (!isIE)
            style = {
              ...style,
              "--backgroundTint": backgroundColor,
              "--backgroundOpacity": backgroundOpacity,
            }

          return (
            <section
              className={cx(styles.container, { [styles.ie]: isIE })}
              style={style}
            >
              <div className={styles.wrapper}>
                <MenuBar variant="white" />
                <div className={styles.contentContainer}>
                  <div>
                    {caseStudy.replaceLogoWithString ? (
                      <span className={styles.textLogo}>
                        {caseStudy.companyLogo}
                      </span>
                    ) : (
                      renderProjectLogo()
                    )}
                  </div>
                  <Tags tags={caseStudy.tags} />
                  <h1 className={styles.title}>{caseStudy.title}</h1>
                </div>
              </div>
            </section>
          )
        }}
      </CaseStudyContext.Consumer>
    )
  }
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/CaseStudy/Hero/index.jsx